/**
 * コレクションセールの期間をクライアント側で再判定し、キャッシュされた HTML の表示を補正する。
 */

function isCollectionSaleActive(startsAt, endsAt) {
  const now = Date.now();

  if (startsAt) {
    const starts = Date.parse(startsAt);
    if (!Number.isNaN(starts) && now < starts) {
      return false;
    }
  }

  if (endsAt) {
    const ends = Date.parse(endsAt);
    if (!Number.isNaN(ends) && now > ends) {
      return false;
    }
  }

  return true;
}

function updateSalePriceElement(salePrice, text) {
  const srOnly = salePrice.querySelector(".sr-only");
  salePrice.textContent = "";

  if (srOnly) {
    salePrice.appendChild(srOnly);
  }

  salePrice.append(document.createTextNode(text));
}

function syncBadgesForPriceList(priceList, active) {
  const root = priceList.closest("product-card, .product-card, [data-collection-sale-root]");

  if (!root) {
    return;
  }

  root.querySelectorAll("[data-collection-sale-badge]").forEach((badge) => {
    badge.hidden = !active;
  });
}

function setPriceListSaleState(priceList, active) {
  const salePrice = priceList.querySelector("sale-price");
  const compareAtPrice = priceList.querySelector("compare-at-price");

  if (!salePrice) {
    return;
  }

  const regularText = priceList.dataset.collectionSaleRegularText || "";
  const saleText = priceList.dataset.collectionSaleSaleText || "";
  const regularClasses = priceList.dataset.collectionSaleRegularClasses || "";
  const onSaleClasses = priceList.dataset.collectionSaleOnSaleClasses || "";
  const compareClasses = priceList.dataset.collectionSaleCompareClasses || "";

  if (active) {
    priceList.setAttribute("data-collection-sale-active", "true");
    salePrice.className = onSaleClasses;

    if (saleText) {
      updateSalePriceElement(salePrice, saleText);
    }

    if (!compareAtPrice && regularText) {
      const compareEl = document.createElement("compare-at-price");
      compareEl.className = compareClasses;
      compareEl.innerHTML = `<span class="sr-only">${priceList.dataset.collectionSaleCompareSrOnly || ""}</span>${regularText}`;
      priceList.appendChild(compareEl);
    }
  } else {
    priceList.removeAttribute("data-collection-sale-active");
    salePrice.className = regularClasses;

    if (regularText) {
      updateSalePriceElement(salePrice, regularText);
    }

    compareAtPrice?.remove();
  }
}

function syncCollectionSalePriceList(priceList) {
  const percent = Number.parseInt(priceList.dataset.collectionSalePercent || "0", 10);

  if (!percent) {
    return;
  }

  const shouldBeActive = isCollectionSaleActive(
    priceList.dataset.collectionSaleStarts || "",
    priceList.dataset.collectionSaleEnds || ""
  );
  const isActive = priceList.hasAttribute("data-collection-sale-active");

  if (shouldBeActive !== isActive) {
    setPriceListSaleState(priceList, shouldBeActive);
  }

  syncBadgesForPriceList(priceList, shouldBeActive);
}

function syncAllCollectionSales(root = document) {
  root.querySelectorAll("price-list[data-collection-sale-percent]").forEach(syncCollectionSalePriceList);
}

function scheduleCollectionSaleTimers() {
  if (window.__collectionSaleTimer) {
    clearTimeout(window.__collectionSaleTimer);
  }

  const now = Date.now();
  let nextChange = null;

  document.querySelectorAll("price-list[data-collection-sale-percent]").forEach((priceList) => {
    const startsAt = priceList.dataset.collectionSaleStarts;
    const endsAt = priceList.dataset.collectionSaleEnds;

    [startsAt, endsAt].forEach((value) => {
      if (!value) {
        return;
      }

      const timestamp = Date.parse(value);

      if (!Number.isNaN(timestamp) && timestamp > now) {
        nextChange = nextChange === null ? timestamp : Math.min(nextChange, timestamp);
      }
    });
  });

  if (nextChange !== null) {
    window.__collectionSaleTimer = setTimeout(() => {
      syncAllCollectionSales();
      scheduleCollectionSaleTimers();
    }, nextChange - now + 100);
  }
}

function initCollectionSaleSync() {
  syncAllCollectionSales();
  scheduleCollectionSaleTimers();
}

document.addEventListener("DOMContentLoaded", initCollectionSaleSync);
window.addEventListener("pageshow", initCollectionSaleSync);
document.addEventListener("variant:change", () => {
  requestAnimationFrame(initCollectionSaleSync);
});
